export enum ProductType {
    ISWL = "iswl"
}
